export { useCompiledLazyLoadQuery } from "./useCompiledLazyLoadQuery";
export { useCompiledFragment } from "./useCompiledFragment";
export { useCompiledRefetchableFragment } from "./useCompiledRefetchableFragment";
export { useCompiledPaginationFragment } from "./useCompiledPaginationFragment";

export type { RefetchFn, Disposable } from "./useCompiledRefetchableFragment";
export type { PaginationFn } from "./useCompiledPaginationFragment";
